import(/* webpackMode: "eager" */ "/vercel/path0/src/app/[workspace]/page.tsx")